"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getArray = getArray;
function getArray(arrayName) {
    const index = Math.floor(Math.random() * arrayName.length);
    return arrayName[index];
}
